import { defineStore } from "pinia";
import { useMakeSaleStore } from "./SaleStore";

export const useAuthStore = defineStore({
  id: "auth",
  state: () => {
    const token = JSON.parse(localStorage.getItem("access_token"));
    return token
      ? { status: { loggedIn: true }, token }
      : { status: { loggedIn: false }, token: null };
  },
  getters: {
    isLoggedIn: (state) => state.status.loggedIn,
  },
  actions: {
    setLogin(business) {
      this.status.loggedIn = true;
      useMakeSaleStore().setBusiness(business);
    },
    logout() {
      localStorage.removeItem("access_token");
      this.status.loggedIn = false;
      this.token = null;
      useMakeSaleStore().clearSaleStore();
      // localStorage.removeItem("auth");
    },
  },
  persist: {
    storage: sessionStorage,
    paths: "pinia-auth",
  },
});
